module.exports = __webpack_public_path__ + "1ec06eed11bbcb1ee510b8f3522adea8.ttf";